import { getToken } from '../../auth/session';
import { peProxy } from '../../api';

const SELECTED_KEY = 'rebelity_pe_tenant_id';

export function getSelectedPeTenantId() {
  return localStorage.getItem(SELECTED_KEY) || '';
}

export function setSelectedPeTenantId(id) {
  if (id == null || id === '') {
    localStorage.removeItem(SELECTED_KEY);
    return;
  }
  localStorage.setItem(SELECTED_KEY, String(id));
}

export function peItems(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.Items)) return data.Items;
  if (Array.isArray(data?.value)) return data.value;
  if (Array.isArray(data?.Value)) return data.Value;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

export function peId(row) {
  return row?.id ?? row?.Id ?? row?.identifier ?? row?.Identifier ?? '';
}

export function peLabel(row) {
  if (!row || typeof row !== 'object') return '—';
  const first = row.firstName ?? row.FirstName;
  const last = row.lastName ?? row.LastName;
  if (first || last) return [first, last].filter(Boolean).join(' ');
  return row.name ?? row.Name ?? row.identifier ?? row.Identifier ?? row.title ?? row.Title ?? String(peId(row) || '—');
}

export function peErrorMessage(res, data, fallback) {
  return data?.message || data?.Message || data?.title || data?.Title || (res && !res.ok ? `Engine request failed (${res.status})` : fallback);
}

export async function peRequest(method, path, body) {
  const token = getToken();
  const { res, data } = await peProxy(token, method, path, body);
  if (!res.ok || data?.status === 'Error') {
    throw new Error(peErrorMessage(res, data, 'Payroll Engine request failed.'));
  }
  return data;
}

export async function peGet(path) {
  return peRequest('GET', path);
}

export async function peList(path) {
  const data = await peGet(path);
  return peItems(data);
}

export async function peCreate(path, body) {
  return peRequest('POST', path, body);
}

export async function peUpdate(path, body) {
  return peRequest('PUT', path, body);
}

export async function peRemove(path) {
  return peRequest('DELETE', path);
}
